import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { ISkillBase } from '../../../types'
import { SelectionOptionPanel } from '../../atoms/SelectionOptionPanel'

type Props = {
  searchWord: string
  skills: ISkillBase[]
  onClickOption: (Skill: ISkillBase) => void
  onClickCreateButton: () => void
}

export const SkillSelectionField: FC<Props> = ({ searchWord, skills, onClickOption, onClickCreateButton }) => {
  const { t } = useTranslation(['search'])

  return (
    <div className={styles.container}>
      <div className={styles.selectItems}>
        {skills?.map((skill) => {
          return (
            <SelectionOptionPanel
              key={skill.id}
              name={skill.name}
              onClick={() => onClickOption(skill)}
              imageStyleType='none'
            />
          )
        })}
      </div>
      {skills.length === 0 && (
        <>
          <p className={styles.noContent}>{t('該当のスキルが見つかりません')}</p>
          {searchWord && (
            <SelectionOptionPanel
              name={t('で新しくスキルを作成', { searchWord: `${searchWord}` })}
              src='/images/common/plus_black_icon.svg'
              onClick={onClickCreateButton}
              imageStyleType='square'
            />
          )}
        </>
      )}
    </div>
  )
}
